module.exports = __webpack_public_path__ + "static/twinRendering1-a53f3faf5f5e0ab5a2340f4419fe2aa8.png";